import { IMAGE_URL } from 'constants/environment';

export const getImageUrl = (url: string, apiURl?: string) => {
  return `${apiURl ?? IMAGE_URL}${url}`;
};

export const checkTypeFile = (fileType: string, type?: string) => {
  const regFile = RegExp(`^.*.(${type ?? 'rar|zip|7z'})$`);

  return regFile.test(fileType);
};

export const getExtFileName = (name: string) => {
  return name.substring(name.lastIndexOf('.'));
};

export const randomString = (length: number) => {
  let result = '';
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return result;
};

export const parseUrlFile = (url: string) => {
  const newUrl = new URL(url);

  return `${newUrl.origin}${newUrl.pathname}`;
};

export function downloadURI(uri: string, name: string = '') {
  const link = document.createElement('a');

  link.setAttribute('download', name);
  link.href = uri;
  link.target = '_blank';
  document.body.appendChild(link);
  link.click();
  link.remove();
}
